<template>
  <b-modal
    :id="`modal-select-template-preview`"
    modal-class="modal-select-template-preview"
    size="xl"
    no-close-on-esc 
    no-close-on-backdrop
    hide-footer
    @shown="init()"
  >
    <template #modal-header>
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-center">
          <div class="modal-title">
            <span class="backIcon cursor-pointer mr-10" @click="close()">
              <i class="fal fa-arrow-left fs-16"></i>
            </span>
            <TitleModal 
              :label="`<span style='color: #AEB5BC;'>${$t('engine.manageAppearance.theme.template.lblTitle', languageEngine)}:</span> ${templateData.templateName}`"
            />
          </div>
          <div>
            <div class="d-flex justify-content-center">
              <ScreenDevicePreview
                :class="{ active: screenSize === 'Desktop' }"
                @click="changePreviewDevice('Desktop')"
                class="text-center d-flex align-items-center justify-content-center"
              >
                <i class="fal fa-desktop"></i>
              </ScreenDevicePreview>
              <ScreenDevicePreview
                :class="{ active: screenSize === 'Tablet' }"
                @click="changePreviewDevice('Tablet')"
                class="text-center d-flex align-items-center justify-content-center"
              >
                <i class="fal fa-tablet"></i>
              </ScreenDevicePreview>
              <ScreenDevicePreview
                :class="{ active: screenSize === 'Mobile' }"
                @click="changePreviewDevice('Mobile')"
                class="text-center d-flex align-items-center justify-content-center"
              >
                <i class="fal fa-mobile"></i>
              </ScreenDevicePreview>
            </div>
          </div>
          <div>
            <a @click="selectTemplate()" v-if="templateData.isAvaliabled">
              <b-button size="md" class="fs-db-20 fw-400" variant="blue" >
                <i class="far fa-check"></i> 
                {{ $t("engine.manageAppearance.theme.template.lblModalSelectTemplateBtn", languageEngine) }}
              </b-button>
            </a>
            <a @click="upgradePackage()" v-else>
              <b-button size="md" class="fs-db-20 fw-400 btnUpgradePackage" variant="black" >
                <img src="@assets/images/icon/crown.webp"/>
                {{ $t("engine.manageAppearance.theme.template.lblModalBuyPackage", languageEngine) }}
              </b-button>
            </a>
            <a @click.stop.prevent="close" >
              <b-button size="md" variant="default" class="px-gd-2 ml-gd-1 fs-db-20 fw-400" id="preview-btn" >
                <i class="far fa-times"></i>
                {{ $t("engine.manageAppearance.theme.template.lblModalClosePreviewBtn", languageEngine) }}
              </b-button>
            </a>
          </div>
        </div>
      </div>
    </template>
  
    <div class="wrapper" style="height: 100%;">
      <div :class="settingScreenSize.device">
        <div
          id="displayDevicePreview"
          :ref="`displayDevicePreview`"
          :class="`h-100 ${settingScreenSize.deviceDisplay}`"
        >
          <div id="displayDeviceWrapper" class="w-100 h-100" style="overflow: hidden;">
            <iframe
              :class="`viewport${screenSize}`"
              id="viewport"
              :ref="`viewport`"
              height="100%"
              :style="{
                '--iframe-scale': iframeScale,
                transform: `scale(${iframeScale})`,
                'transform-origin': 'top left',
                height: `calc(100%/${iframeScale})`,
                width: `calc(100%/${iframeScale})`,
              }"
              :src="`//${templateData.templateUrl}/?pointer=none`"
            >
            </iframe>
          </div>
        </div>
        <div :class="settingScreenSize.device1"></div>
        <div :class="settingScreenSize.device2"></div>
        <div :class="settingScreenSize.device3"></div>
        <div :class="settingScreenSize.device4"></div>
      </div>
    </div>    
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import styled from "vue-styled-components";

const ScreenDevicePreview = styled.div`
  height: 48px;
  width: 56px;
  font-size: 24px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #CDD3DA;
  &::after {
    transition: all 0.1s ease;
    content: "";
    position: absolute;
    width: 100%;
    height: 0px;
    background-color: #24BEE2;
    bottom: -5px;
  }

  &.active,
  &:hover {
    color: #24BEE2;
    &::after {
      height: 5px;
    }
  }
`;

export default {
  data() {
    return {
      screenSize: "Desktop",
      iframeScale: 1,
    };
  },
  components :{
    TitleModal,
    ScreenDevicePreview
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
    settingScreenSize() {
      switch (this.screenSize) {
        case "Mobile":
          return {
            device: "device device-iphone-x",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-btns",
            device3: "device-power",
            device4: "device-home",
          };
        case "Tablet":
          return {
            device: "device device-ipad-pro device-spacegray",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-header",
            device3: "device-sensors",
            device4: "device-btns",
          };

        default:
          return {
            device: "device device-desktop h-100",
            deviceDisplay: "device-frame drop-shadow",
          };
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.screebSize = "Desktop";
    },
    changePreviewDevice(device) {
      this.screenSize = device;
    },
    handleResize() {
      // desktop min width 1366
      const scale = this.$refs.displayDevicePreview.clientWidth / 1366;
      this.iframeScale = scale < 1 && this.screenSize === "Desktop" ? scale : 1;
    },
    selectTemplate() {
      this.$emit('selectTemplate', this.templateData);
    },
    upgradePackage() {
      this.$bvModal.show('modal-confirm-upgrade-insert');
    },
    close() {
      this.$bvModal.hide(`modal-select-template-preview`);
      this.$bvModal.show(`modal-select-template-website`);
    },
  },
  watch: {
    screenSize: function () {
      setTimeout(this.handleResize, 400);
    },
  },
  props : {
    templateData: {
        type: Object,
        require: true,
    },
  }
}
</script>

<style lang="scss">
.modal-select-template-preview {
  .modal-content {
    height: 100%;
    border: 1px solid #DEE3E6;
  }
  .modal-body {
    padding: 0;
    height: calc(95vh - 130px);
    overflow-y: scroll;
  }
  /*! v0.1.16 */
  .device,
  .device::before,
  .device::after,
  .device *,
  .device *::before,
  .device *::after {
    box-sizing: border-box;
    display: block;
  }

  .device {
    position: relative;
    transform: scale(1);
    z-index: 1;
  }

  .device .device-frame {
    z-index: 1;
  }

  .device .device-content {
    background-color: #fff;
    background-position: center center;
    background-size: cover;
    object-fit: cover;
    position: relative;
  }

  .device-iphone-x {
    height: 868px;
    width: 431px;
  }

  .device-iphone-x .device-frame {
    background: #222;
    border-radius: 68px;
    box-shadow: inset 0 0 2px 2px #c8cacb, inset 0 0 0 7px #e2e3e4;
    height: 868px;
    padding: 28px;
    width: 431px;
  }

  .device-iphone-x .device-content {
    border-radius: 40px;
    height: 812px;
    width: 375px;
  }

  .device-iphone-x .device-stripe::after,
  .device-iphone-x .device-stripe::before {
    pointer-events: none;
    border: solid rgba(51, 51, 51, 0.25);
    border-width: 0 7px;
    content: "";
    height: 7px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 9;
  }

  .device-iphone-x .device-stripe::after {
    top: 85px;
  }

  .device-iphone-x .device-stripe::before {
    bottom: 85px;
  }

  .device-iphone-x .device-header {
    background: #222;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 30px;
    left: 50%;
    margin-left: -102px;
    position: absolute;
    top: 28px;
    width: 204px;
  }

  .device-iphone-x .device-header::after,
  .device-iphone-x .device-header::before {
    content: "";
    height: 10px;
    position: absolute;
    top: 0;
    width: 10px;
  }

  .device-iphone-x .device-header::after {
    background: radial-gradient(
      circle at bottom left,
      transparent 0,
      transparent 75%,
      #222 75%,
      #222 100%
    );
    left: -10px;
  }

  .device-iphone-x .device-header::before {
    background: radial-gradient(
      circle at bottom right,
      transparent 0,
      transparent 75%,
      #222 75%,
      #222 100%
    );
    right: -10px;
  }

  .device-iphone-x .device-sensors::after,
  .device-iphone-x .device-sensors::before {
    content: "";
    position: absolute;
  }

  .device-iphone-x .device-sensors::after {
    background: #444;
    border-radius: 3px;
    height: 6px;
    left: 50%;
    margin-left: -25px;
    top: 32px;
    width: 50px;
  }

  .device-iphone-x .device-sensors::before {
    background: #444;
    border-radius: 50%;
    height: 14px;
    left: 50%;
    margin-left: 40px;
    top: 28px;
    width: 14px;
  }

  .device-iphone-x .device-btns {
    background: #c8cacb;
    height: 32px;
    left: -3px;
    position: absolute;
    top: 115px;
    width: 3px;
  }

  .device-iphone-x .device-btns::after,
  .device-iphone-x .device-btns::before {
    background: #c8cacb;
    content: "";
    height: 62px;
    left: 0;
    position: absolute;
    width: 3px;
  }

  .device-iphone-x .device-btns::after {
    top: 60px;
  }

  .device-iphone-x .device-btns::before {
    top: 140px;
  }

  .device-iphone-x .device-power {
    background: #c8cacb;
    height: 100px;
    position: absolute;
    right: -3px;
    top: 200px;
    width: 3px;
  }
  .device-ipad-pro {
    /*height: 804px;*/
    height: 1148px;
    /*width: 560px;*/
    width: 818px;
  }
  .device-ipad-pro .device-frame {
    background: #fff;
    border-radius: 38px;
    box-shadow: inset 0 0 0 2px #c8cacb, inset 0 0 0 6px #e2e3e4;
    /*height: 804px;*/
    height: 1148px;
    padding: 62px 25px;
    /*width: 560px;*/
    width: 818px;
  }

  .device-ipad-pro .device-content {
    border: 2px solid #222;
    border-radius: 2px;
    height: 680px;
    width: 510px;
  }

  .device-ipad-pro .device-header {
    border: 2px solid #c8cacb;
    border-radius: 50%;
    bottom: 17px;
    height: 34px;
    left: 50%;
    margin-left: -17px;
    position: absolute;
    width: 34px;
  }

  .device-ipad-pro .device-sensors {
    background: #666;
    border-radius: 50%;
    height: 10px;
    left: 50%;
    margin-left: -5px;
    margin-top: -5px;
    position: absolute;
    top: 34px;
    width: 10px;
  }

  .device-ipad-pro.device-gold .device-frame {
    box-shadow: inset 0 0 0 2px #e4b08a, inset 0 0 0 6px #f7e8dd;
  }

  .device-ipad-pro.device-gold .device-header {
    border-color: #e4b08a;
  }

  .device-ipad-pro.device-rosegold .device-frame {
    box-shadow: inset 0 0 0 2px #f6a69a, inset 0 0 0 6px #facfc9;
  }

  .device-ipad-pro.device-rosegold .device-header {
    border-color: #f6a69a;
  }

  .device-ipad-pro.device-spacegray .device-frame {
    background: #222;
    box-shadow: inset 0 0 0 2px #818187, inset 0 0 0 6px #9b9ba0;
  }
  .device-ipad-pro.device-spacegray .device-frame #viewport {
    background: #ffffff;
  }
  .device.device-iphone-x #viewport {
    background: #ffffff;
  }
  .device-ipad-pro.device-spacegray .device-header {
    border-color: #818187;
  }
  .device-desktop {
    /*height: 804px;*/
    /* height: 1148px; */
    /*width: 560px;*/
    /* width: 818px; */
  }

  .device-desktop .device-frame {
    /* background: #fff; */
    /* box-shadow: 0 0 4px rgba(0,0,0,0.1),0 1px 2px rgba(0,0,0,0.1);; */
    iframe {

    /* border-radius: 5px; */
    }
    /*height: 804px;*/
    /* height: 1148px; */
    /* padding: 62px 25px; */
    /* padding: 15px; */
    /* padding: 15px 15px 0 15px; */
    /* overflow: hidden;
    overflow-x: scroll; */
    /*width: 560px;*/
    /* width: 818px; */
  }

  .device-desktop .device-content {
    border: 2px solid #222;
    border-radius: 2px;
    /* height: 680px;
    width: 510px; */
  }

  .device-desktop .device-header {
    border: 2px solid #c8cacb;
    border-radius: 50%;
    bottom: 17px;
    height: 34px;
    left: 50%;
    margin-left: -17px;
    position: absolute;
    width: 34px;
  }

  .device-desktop .device-sensors {
    background: #666;
    border-radius: 50%;
    height: 10px;
    left: 50%;
    margin-left: -5px;
    margin-top: -5px;
    position: absolute;
    top: 34px;
    width: 10px;
  }
  .wrapper-system{
    overflow-y: scroll;
    overflow-x: hidden;
     background-color: #f8f9fa;
  }

  .btnUpgradePackage {
    img {
      margin-top: -4px;
      height: 16px;
    }
  }
}
  #modal-select-template-preview {
    .modal-header {
      padding: 4px 1rem;
    }
  }
</style>